<script>
export default {
    name: 'IlluPartnership',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7',
        },

        secondaryColor: {
            type: String,
            default: '#313132',
        },
    },
}
</script>
<template>
    <svg role="img"
        class="base-illu illu-partnership"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M26 21.5c.593.119 1.467.603 2.496 1.293L23 26v2.5l2.5 1L27 29l5.123-3.522 2.81 2.196.891.683c1.161.88 2.204 1.62 2.986 2.044l.19.099c1.792.896 4.386 3.129 7.782 6.7.683.717.669 1.85-.032 2.55a2.038 2.038 0 01-2.664.19L41.5 38l1.85 2.158a1.909 1.909 0 01-2.692 2.692L38.5 41l1.958 2.285a1.547 1.547 0 01-.168 2.182l-.04.033c-.74.592-1.782.62-2.553.07L35.5 44l-.5.5.97.97a1.138 1.138 0 01-.22 1.78 2.43 2.43 0 01-2.5 0L32 46.5l-.326-.348L33 43.5c.5-1 0-1.5-.5-2.5-.333-.667-1.333-.667-3 0 .333-1.667.167-2.833-.5-3.5-.667-.667-1.5-.667-2.5 0-.333-.667-.833-1.333-1.5-2s-1.5-.333-2.5 1c-.333-1.667-1-2.5-2-2.5s-1.667.5-2 1.5l-.137 1.507c-1.166-.647-.453-1.483-.863-2.507l3.5-10c2.333-2 3.333-3.333 5-3zm-10.022-1.588l2.506.912a2.667 2.667 0 011.594 3.418L16.43 34.265a2.667 2.667 0 01-3.418 1.594l-2.506-.912a2.667 2.667 0 01-1.594-3.418l3.648-10.023a2.667 2.667 0 013.418-1.594zM13 31a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
                :fill="primaryColor"
                class="primary-color"
            />
            <path
                d="M23.6 25.43a1.5 1.5 0 00-.717 1.097l-.132 1.036a1.51 1.51 0 001.313 1.686l1.304.16a1.5 1.5 0 001.053-.268l5.275-3.762 13.859 10.535 2.321-1.161-3.042-8.258a1.5 1.5 0 00-.835-.868l-11.574-4.781c-.562-.232-1.275.058-8.825 4.584zM20.5 34.5c-.378 0-.697.085-.95.275-.249.187-.429.468-.558.83l-.483 5.32c.28.671.58 1.156.928 1.435.274.219.576.275 1.312-.09.049.17.115.34.198.506.284.568.71.993 1.277 1.277a.587.587 0 00.552 0c.274-.137.536-.423.808-.83l1.601-2.402-.7 2.8c-.134.538-.156.979-.02 1.318.114.287.354.474.693.587.842.28 1.551.31 2.118.027L28 45.19V46c0 .378.085.697.275.95.195.26.495.446.883.576.387.128.71.179.97.114.193-.048.33-.174.425-.364l2-4c.321-.642.06-1.014-.231-1.546-.086-.156-.178-.323-.822-.73-.455 0-1.058.162-1.814.464a8.838 8.838 0 00-.93.427c.097-.296.181-.627.254-.99.284-1.42.22-2.464-.364-3.047-.228-.229-.483-.354-.771-.354-.335 0-.699.15-1.098.416a3.09 3.09 0 00-.477.382 5.657 5.657 0 00-.247-.574c-.312-.624-.783-1.247-1.992-2.01-.358.143-.736.519-1.161 1.086l-.671.895-.22-1.097c-.146-.734-.355-1.292-.65-1.66-.229-.287-.513-.438-.859-.438z"
                :stroke="secondaryColor"
                class="secondary-color"
            />
            <rect
                :stroke="secondaryColor"
                class="secondary-color"
                transform="scale(-1 1) rotate(20 0 -251.814)"
                x="45.995"
                y="21.386"
                width="7"
                height="15"
                rx="2"
            />
            <circle
                :fill="secondaryColor"
                class="secondary-color"
                transform="matrix(-1 0 0 1 101.8 0)"
                cx="50.9"
                cy="32.5"
                r="1.5"
            />
            <path
                :stroke="secondaryColor"
                class="secondary-color"
                stroke-linecap="round"
                d="M21.75 38.25l-.5 2.5M26 39.25l-1 2.5M28.75 43l-.5 1"
            />
        </g>
    </svg>
</template>
